<template>
  <div class="recording-length-screen">
    <h1>What's the typical length of your recordings?</h1>
    <p class="subtitle">Select all that apply</p>

    <form
      @submit.prevent="handleSubmit"
      class="login-form"
      :class="{ 'error-active': hasErrors }"
    >
      <div class="length-options">
        <div
          v-for="option in lengthOptions"
          :key="option.value"
          class="onboarding-option-card"
          :class="{
            selected: preferences.recordingLengths.includes(option.value),
          }"
          @click.prevent="toggleLength(option.value)"
        >
          <div class="onboarding-checkbox-container">
            <span
              class="onboarding-checkbox-box"
              :class="{
                checked: preferences.recordingLengths.includes(option.value),
              }"
            ></span>
            <span class="onboarding-checkbox-text">
              <span class="checkbox-title">{{ option.label }}</span>
              <span class="checkbox-description">{{ option.description }}</span>
            </span>
          </div>
        </div>
      </div>

      <div
        v-if="validationErrors.recordingLengths"
        class="onboarding-form-error"
      >
        <span class="error-icon icon-exclamation-mark"></span>
        <span class="error-txt">{{ validationErrors.recordingLengths }}</span>
      </div>

      <div class="onboarding-nav-buttons">
        <button
          type="button"
          class="btn btn-secondary"
          @click="$emit('prevStep')"
        >
          Back
        </button>
        <input
          type="submit"
          class="btn btn-primary"
          value="Next"
          :disabled="isSubmitting"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { useOnboardingStore } from "@/stores/onboarding-store";
import { mapStores } from "pinia";
import { analytics } from "@/services/analytics.service";

export default {
  name: "RecordingLengthScreen",
  computed: {
    ...mapStores(useOnboardingStore),
    preferences() {
      return this.onboardingStore.preferences;
    },
    validationErrors() {
      return this.onboardingStore.validationErrors;
    },
    isSubmitting() {
      return this.onboardingStore.isSubmitting;
    },
    hasErrors() {
      return Object.keys(this.validationErrors).length > 0;
    },
  },
  mounted() {
    // Track step 2 viewed
    analytics.onboardingStep2Viewed();
  },
  data() {
    return {
      lengthOptions: [
        { value: "SHORT", label: "Short", description: "< 15 minutes" },
        { value: "MEDIUM", label: "Medium", description: "15-30 minutes" },
        { value: "LONG", label: "Long", description: "30-60 minutes" },
        { value: "VERY_LONG", label: "Very Long", description: "> 60 minutes" },
      ],
    };
  },
  methods: {
    toggleLength(value) {
      // Create a new array to ensure reactivity
      let newRecordingLengths = [...this.preferences.recordingLengths];

      if (newRecordingLengths.includes(value)) {
        newRecordingLengths = newRecordingLengths.filter(
          (item) => item !== value,
        );
      } else {
        newRecordingLengths.push(value);
      }

      // Use direct assignment to ensure reactivity
      this.preferences.recordingLengths = newRecordingLengths;
      this.onboardingStore.validationErrors = {};

      // Track recording length toggled
      analytics.onboardingRecordingLengthToggled({
        length: value,
        selected: newRecordingLengths.includes(value),
        total_selected: newRecordingLengths.length,
      });
    },
    handleSubmit() {
      if (this.onboardingStore.validateCurrentStep()) {
        // Track step 2 completed
        analytics.onboardingStep2Completed({
          recording_lengths: this.preferences.recordingLengths,
        });

        this.$emit("nextStep");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.recording-length-screen {
  @include onboarding-screen-title;

  h1 {
    margin-bottom: 8px;
  }

  .subtitle {
    font-size: 14px;
    color: rgba($white, 0.6);
    text-align: center;
    margin-bottom: 24px;

    @media (min-width: 768px) {
      margin-bottom: 30px;
    }
  }
}

.length-options {
  @include onboarding-options-list;
  margin-bottom: 15px;
}
</style>
